// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"22a9f930","205":"467a694d","274":"b46c3cdc","353":"d34634ef","456":"83ba8cc1","546":"75843d38","678":"33eb4dd5","744":"3130605f","885":"7589ca0a","963":"06c9bcd3"}[chunkId] + ".chunk.js";
};